import { EntityState } from '@ngrx/entity';
import { AvailableSchedule, ClassroomCourse, ClassroomCourseFilter } from '../models';
import { Participant } from '../models/participant';

export const classroomFeatureKey = 'classroom';

export interface ClassroomCourseState extends EntityState<ClassroomCourse> {
  selectedCourseId: string;
  schedules: AvailableSchedule[];
  instructorCourses: ClassroomCourse[];
  error: any;
  totalCount: number;
  filter: ClassroomCourseFilter;
  participantIdentity: Participant;
}
